export function isDataExist (chartData) {
    for (const data of chartData) {
        if (data.count > 0) {
            return true;
        }
    }
    return false;
};
